import { clearNullish } from "../../../xconfig/utils.js";
import { xget, xhttp } from "../Fetchv2.js";
import { PGSchema } from "../schemas/pg.schema.js";

export class ProductsAPI {
	async getProducts(query: { active?: boolean; frequency?: string; currency?: string; orderBy?: string; limit?: number; page?: number }) {
		return xget<PGSchema.products[]>("/admin/products", query);
	}

	async createProduct(planData: Partial<PGSchema.products>) {
		return xhttp<PGSchema.products>("/admin/products", "POST", planData);
	}

	async getProduct(id: number) {
		return xget<PGSchema.products>(`/admin/products/${id}`);
	}

	async updateProduct(planID: number, planData: Partial<PGSchema.products>) {
		const { id, created_at, updated_at, psm_prices, psm_subscriptions, psm_invoice, ...planDataClean } = planData;
		clearNullish(planDataClean);
		return xhttp<PGSchema.products>(`/admin/products/${planID}`, "PUT", planDataClean);
	}

	async InactiveProduct(id: number) {
		return xhttp<PGSchema.products>(`/admin/products/${id}`, "DELETE", {});
	}

	async getActiveProducts() {
		return xget<PGSchema.products[]>("/products");
	}
}
